/* eslint-disable react/jsx-no-target-blank */
import { Box, Center, Drawer, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, Link as ChakraLink, useDisclosure } from "@chakra-ui/react";
import CommonButton from "../../common/CommonButton";
import InvestingDrawer from "../../common/InvestingDrawer";
import QuestionMenu from "../../common/QuestionMenu";
import LandingSectionCard from "./LandingSectionCard";
import { landingSectionCardData } from "./LandingSectionCardData";
import LandingStatCard from "./LandingStatCard";
import { landingStatData } from "./LandingStatData";

export default function LandingSection() {

  const { isOpen, onOpen, onClose } = useDisclosure();
  
  return (
    <Flex
      w="full"
      alignItems="center"
      position="relative"
      justify="center"
      fontFamily="'IBM Plex Mono', monospace"
    >
      <Center>
        <Flex
          position="relative"
          direction="column"
          w="full"
          color="rgb(0 0 0 / 85%)"
          alignItems="center"
          maxW="55rem"
          gap={[6]}
          py={[6, 6, 20, 16]}
          px={[6, 6, 8, 0]}
        >
          <Box
            fontSize={["4xl", "4xl", "6xl", "7xl"]}
            fontWeight="semibold"
            w="full"
            mb="-4"
            fontFamily="'Poppins', sans-serif"
          >
            Credix
          </Box>
          <Box
            fontFamily="'IBM Plex Mono', monospace"
            fontSize={["sm"]}
            lineHeight="1.75rem"
          >
            Connecting investors globally with credit opportunities in emerging
            markets. Start earning stable yield, backed by real world assets.
          </Box>
          <Flex
            direction={["column", "column", "row", "row", "row"]}
            w="full"
            gap={6}
          >
            {landingStatData.map(({ title, data }) => (
              <LandingStatCard key={title} title={title} data={data} />
            ))}
          </Flex>
          <Box display={["block", "block", "none", "none"]} w="full">
            <CommonButton
              name="Start investing"
              onClick={() => {
                console.log("clicked");
              }}
              bg="rgba(187, 247, 208, 1)"
              hoverBg="rgba(74, 222, 128, 1)"
            />
          </Box>
          <Flex
            direction={["column", "column", "row", "row", "row"]}
            w="full"
            pt={[10, 10, 0, 0]}
            gap={6}
          >
            {landingSectionCardData.map(({ title, data, link }) => (
              <LandingSectionCard
                key={title}
                title={title}
                data={data}
                link={link}
              />
            ))}
          </Flex>
          <Flex
            justify={["end", "end", "space-between", "space-between"]}
            alignItems="center"
            w="full"
          >
            <Box display={["none", "none", "block", "block"]}>
              <CommonButton
                name="Start investing"
                onClick={onOpen}
                bg="rgba(187, 247, 208, 1)"
                hoverBg="rgba(74, 222, 128, 1)"
              />
              <Drawer size="full" onClose={onClose} isOpen={isOpen}>
                <DrawerOverlay />
                <DrawerContent
                  bg="rgba(245, 245, 245, 1)"
                >
                  <DrawerHeader>
                    <InvestingDrawer onDrawerClose={onClose} />
                  </DrawerHeader>
                  <DrawerFooter></DrawerFooter>
                </DrawerContent>
              </Drawer>
            </Box>
            <Flex gap={4}>
              <Box>
                <ChakraLink
                  fontSize={["sm"]}
                  textDecoration="underline"
                  fontWeight="medium"
                >
                  <a
                    href="https://docs.credix.finance/other-links-and-resources/faq"
                    target="_blank"
                  >
                    FAQ
                  </a>
                </ChakraLink>
              </Box>
              <Box>
                <ChakraLink
                  fontSize={["sm"]}
                  textDecoration="underline"
                  fontWeight="medium"
                >
                  <a
                    href="https://credixfinance.docsend.com/view/s/ni6g3tvkv75j5izu"
                    target="_blank"
                  >
                    Data room
                  </a>
                </ChakraLink>
              </Box>
            </Flex>
          </Flex>
        </Flex>
      </Center>
    </Flex>
  );
}
